import DataLoader from 'dataloader';
import { getCfjsonBatcher, getDatasetBatcher } from './movIntegrationMDS/batcher';
import { getWidgetblockBatcher } from './platformsWidgetblock/batcher';
const defaultBatchScheduleTimeout = 32;
let getCfjsonLoader = new DataLoader(getCfjsonBatcher, {
    batchScheduleFn: (callback) => setTimeout(callback, defaultBatchScheduleTimeout),
});
let getDatasetLoader = new DataLoader(getDatasetBatcher, {
    batchScheduleFn: (callback) => setTimeout(callback, defaultBatchScheduleTimeout),
});
let getWidgetblockLoader = new DataLoader(getWidgetblockBatcher, {
    batchScheduleFn: (callback) => setTimeout(callback, defaultBatchScheduleTimeout),
});
export const setBatchTimout = (batchScheduleTimeout) => {
    getCfjsonLoader = new DataLoader(getCfjsonBatcher, {
        batchScheduleFn: (callback) => setTimeout(callback, batchScheduleTimeout),
    });
    getDatasetLoader = new DataLoader(getDatasetBatcher, {
        batchScheduleFn: (callback) => setTimeout(callback, batchScheduleTimeout),
    });
    getWidgetblockLoader = new DataLoader(getWidgetblockBatcher, {
        batchScheduleFn: (callback) => setTimeout(callback, batchScheduleTimeout),
    });
};
export const getLoaders = () => {
    return {
        movIntegrationMds: {
            getCfjsonLoader,
            getDatasetLoader,
        },
        platformsWidgetblock: {
            getWidgetblockLoader,
        },
    };
};
